import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentGql } from './WorkbooksDisplayGridRowDataFragmentGql';

export const VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamWorkbooksFilteredByColumnQuery(
  $vizportalUrlId: String!,
  $selectedColumnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: WorkbookSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    columnsConnection(filter: { id: $selectedColumnId }) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentGql}
`;
